import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/brands.css';
import './styles.css';
import { socials } from './config/socials';
import { socialQrPaths } from './generated/social-qrs';

const app = document.querySelector<HTMLDivElement>('#app');

if (!app) {
  throw new Error('App root was not found.');
}

const copyHandle = async (value: string, target: HTMLElement) => {
  try {
    await navigator.clipboard.writeText(value);
    target.dataset.state = 'copied';
    window.setTimeout(() => {
      target.dataset.state = 'idle';
    }, 1400);
  } catch {
    target.dataset.state = 'failed';
    window.setTimeout(() => {
      target.dataset.state = 'idle';
    }, 1800);
  }
};

const renderSocialSurface = (social: (typeof socials)[number]) => {
  const content = `
    <span class="social-icon" aria-hidden="true"><i class="${social.iconClass}"></i></span>
    <span class="social-copy">
      <span class="social-label">${social.label}</span>
      <span class="social-handle">${social.handle}</span>
    </span>
  `;

  if (!social.href && social.copyValue) {
    return `<button class="social-link social-action" type="button" data-copy-surface="${social.copyValue}" aria-label="Copy ${social.label} handle">${content}</button>`;
  }

  if (!social.href) {
    return `<div class="social-link" aria-label="${social.label} ${social.handle}">${content}</div>`;
  }

  return `<a class="social-link" href="${social.href}" ${social.rel ? `rel="${social.rel}"` : ''}>${content}</a>`;
};

app.innerHTML = `
  <main class="landing-shell" aria-labelledby="page-title">
    <div class="energy-field" aria-hidden="true">
      <span class="spark spark-one"></span>
      <span class="spark spark-two"></span>
      <span class="spark spark-three"></span>
      <span class="sigil-ring"></span>
    </div>
    <section class="profile-stage">
      <div class="avatar-wrap" aria-hidden="true">
        <img class="avatar" src="/avatar.jpg" alt="" width="240" height="240" />
      </div>
      <div class="identity">
        <h1 id="page-title">Yangff</h1>
        <p class="tagline">Find me here</p>
      </div>
      <nav class="social-grid" aria-label="Social links">
        ${socials
          .map(
            (social) => `
              <article class="social-card" style="--accent: ${social.accent}">
                ${renderSocialSurface(social)}
                ${
                  social.copyValue
                    ? `<button class="copy-button" type="button" data-copy="${social.copyValue}" aria-label="Copy ${social.label} handle">
                        <span data-idle>Copy</span>
                        <span data-copied>Copied</span>
                        <span data-failed>Failed</span>
                      </button>`
                    : ''
                }
                <div class="qr-popover" aria-hidden="true">
                  <img src="${socialQrPaths[social.id]}" alt="" loading="lazy" width="148" height="148" />
                  <span>Scan ${social.label}</span>
                </div>
              </article>
            `,
          )
          .join('')}
      </nav>
    </section>
  </main>
`;

document.querySelectorAll<HTMLButtonElement>('[data-copy]').forEach((button) => {
  button.dataset.state = 'idle';
  button.addEventListener('click', () => {
    const value = button.dataset.copy;
    if (value) {
      void copyHandle(value, button);
    }
  });
});

document.querySelectorAll<HTMLButtonElement>('[data-copy-surface]').forEach((button) => {
  button.dataset.state = 'idle';
  button.addEventListener('click', () => {
    const value = button.dataset.copySurface;
    if (value) {
      void copyHandle(value, button);
    }
  });
});